import { gql } from '@apollo/client';

export const VALIDATE_TWO_FACTOR = gql`
  mutation validateTwoFactor {
    validateTwoFactor(input: $input)
      @rest(type: "TwoFactor", path: "/v4/auth/2fa/validate", method: "POST")
  }
`;
